export default {
  title: 'Panoramica',
  table_title: 'Prenotazioni',
  filters: {
    card_title: 'Filtri',
    today: 'Oggi',
    upcoming: 'Prossime',
    past: 'Passate',
    all: 'Tutte',
    all_dates: 'Sempre',
    pending: 'In attesa di conferma',
    canceled: 'Annullata',
    removed: 'Rimossa',
    date_label: 'Data:',
    status_label: 'Stato:',
    source_label: 'Fonte:',
    source_website: 'Sito web',
    source_google: 'Google',
    search_label: 'Cerca:',
    search_placeholder: 'Cerca per nome o cognome',
    custom_date_tooltip: 'Scegli una data specifica',
    active_label: 'Filtri attivi:',
    clear_all: 'Cancella tutto',
  },
  tooltips: {
    total_reservations: 'Prenotazioni totali',
    total_guests: 'Ospiti totali',
    refresh: 'Aggiorna',
  },
  empty: {
    default: 'Nessuna prenotazione ancora.',
    filtered: 'Nessuna prenotazione corrisponde ai filtri.',
  },
  fields: {
    company: 'Ristorante',
    datetime: 'Data / ora',
    customer: 'Cliente',
    source: 'Fonte',
    guests: 'Ospiti',
    status: 'Stato',
    created_at: 'Creata il',
  },
  status: {
    confirmed: 'Confermata',
    pending: 'In attesa di approvazione',
    canceled: 'Annullata',
    rejected: 'Rifiutata',
    removed: 'Rimossa',
  },
  buttons: {
    details: 'Dettagli',
    add_reservation: 'Aggiungi prenotazione',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
